module.exports = "/images/vendor/desiigner-svg/svg/ui/faux-left-arrow.svg?510f5dc8af00a45141ea9bdf2f2f8e4d";